import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Logo } from './logo.model';
import * as LogoActions from './logo.actions';

export const logoesFeatureKey = 'logoes';

export interface State extends EntityState<Logo> {
  // additional entities state properties
}

export const adapter: EntityAdapter<Logo> = createEntityAdapter<Logo>({selectId: (model: Logo) => model.Uploadtype});

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});


export const logoReducer = createReducer(
  initialState,
  on(LogoActions.addLogo,
    (state, action) => adapter.addOne(action.logo, state)
  ),
  on(LogoActions.upsertLogo,
    (state, action) => adapter.upsertOne(action.logo, state)
  ),
  on(LogoActions.addLogos,
    (state, action) => adapter.addMany(action.logos, state)
  ),
  on(LogoActions.upsertLogos,
    (state, action) => adapter.upsertMany(action.logos, state)
  ),
  on(LogoActions.updateLogo,
    (state, action) => adapter.updateOne(action.logo, state)
  ),
  on(LogoActions.updateLogos,
    (state, action) => adapter.updateMany(action.logos, state)
  ),
  on(LogoActions.deleteLogo,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(LogoActions.deleteLogos,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(LogoActions.loadLogos,
    (state, action) => adapter.setAll(action.logos, state)
  ),
  on(LogoActions.clearLogos,
    state => adapter.removeAll(state)
  ),
);

export function reducer(state: State | undefined, action: Action) {
  return logoReducer(state, action);
}

export const selectLogoState = createFeatureSelector<State>(
  logoesFeatureKey
);


export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors(selectLogoState);
